import { AlertCircle } from 'lucide-react';
import { buttonClass } from './CheckoutControls';

/**
 * Fallback for the public `/checkout` route. Deliberately shows no error name,
 * message or component stack — anonymous visitors get a branded message while
 * the detail goes to `reportClientError` only.
 */
export default function CheckoutErrorFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#efeaf1] px-4 py-10 text-[#3d1751]">
      <div className="w-full max-w-[460px] rounded-2xl bg-white p-7 text-center shadow-[0_14px_40px_rgba(61,23,81,0.16)]">
        <p className="text-[19px] font-extrabold text-[#3d1751]">
          World<span className="font-serif italic font-normal text-[#4b0a5b]">Via</span>
        </p>
        <span
          aria-hidden="true"
          className="mx-auto mb-4 mt-5 flex h-12 w-12 items-center justify-center rounded-full bg-[#fffbfb]"
        >
          <AlertCircle className="h-7 w-7 text-[#dc2626]" />
        </span>
        <h1 className="m-0 mb-2 text-xl font-bold text-[#4b0a5b]">Checkout hit a snag</h1>
        <p className="mb-5 text-[13px] leading-relaxed text-[#7a6a8c]">
          Nothing has been charged and your progress is saved. Reload to pick up where you left off,
          or call us on{' '}
          <a href="tel:+18558467821" className="font-medium text-[#b82f74] hover:underline">
            (855) 846-7821
          </a>{' '}
          and we’ll finish it with you.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className={`${buttonClass('sm')} px-6`}
        >
          Reload checkout
        </button>
      </div>
    </div>
  );
}
